import { api, buildQueryParams, URLs } from '@/libs/api'
import type {
  ApiResponse,
  CursorPaginatedResponse,
  UnionAgreement,
  UnionAgreementList,
  UnionAgreementListParams,
  UnionAgreementPayload,
} from '@/libs/interfaces'
import { IS_MOCK_MODE } from '@/libs/mocks/config'
import { unionAgreementsApiMock } from '@/libs/mocks/handlers/unionAgreements'

const unionAgreementsApiReal = {
  create: async (orgID: string, payload: UnionAgreementPayload): Promise<UnionAgreement> => {
    return api
      .post<ApiResponse<UnionAgreement>>(URLs.UnionAgreements.create(orgID), payload)
      .then((r) => r.data.data)
  },

  getByID: async (orgID: string, id: string): Promise<UnionAgreement> => {
    return api
      .get<ApiResponse<UnionAgreement>>(URLs.UnionAgreements.byID(orgID, id))
      .then((r) => r.data.data)
  },

  update: async (
    orgID: string,
    id: string,
    payload: Partial<UnionAgreementPayload>,
  ): Promise<UnionAgreement> => {
    return api
      .patch<ApiResponse<UnionAgreement>>(URLs.UnionAgreements.byID(orgID, id), payload)
      .then((r) => r.data.data)
  },

  delete: async (orgID: string, id: string): Promise<void> => {
    await api.delete(URLs.UnionAgreements.byID(orgID, id))
  },

  list: async (orgID: string): Promise<UnionAgreement[]> => {
    return api
      .get<ApiResponse<UnionAgreementList>>(URLs.UnionAgreements.list(orgID, ''))
      .then((r) => r.data.data.data || [])
  },
  listCursor: async (
    params: UnionAgreementListParams,
  ): Promise<CursorPaginatedResponse<UnionAgreement>> => {
    const { orgID, ...queryParams } = params
    const query = buildQueryParams(queryParams)
    const response = await api
      .get<ApiResponse<UnionAgreementList>>(URLs.UnionAgreements.list(orgID ?? '', query))
      .then((response) => response?.data?.data)

    return {
      data: response?.data || [],
      pageInfo: {
        first: response.first,
        prev: response.prev,
        cursor: response.cursor,
        next: response.next,
        last: response.last,
      },
    }
  },
}

export const unionAgreementsApi: typeof unionAgreementsApiReal = IS_MOCK_MODE
  ? unionAgreementsApiMock
  : unionAgreementsApiReal
